/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import TopTitlePage from '../../components/TopTitlePage'
import { Button, Card, Container, Form, Offcanvas, Row } from 'react-bootstrap'
import Loading from '../../components/Loading'
import { SweetAlert } from '../../components/sweetalert'

import ReactPaginate from 'react-paginate';
import './style.css'
import { useForm } from 'react-hook-form'
import { URL } from '../../config/url'
import { useNavigate } from 'react-router-dom'
import Status from '../../services/Status'
import ButtonFilterAndSelect from '../../components/ButtonFilterAndSelect'
import ButtonLimparAndFiltrar from '../../components/ButtonLimparAndFiltrar'

import TableList from '../../components/TableComponents/TableList'
import TableData from './TableData'

const ListaStatus = () => {

  const { register, getValues, handleSubmit, reset } = useForm()
  const navigate = useNavigate()

  const [statusAtendimento, setStatusAtendimento] = useState([])
  const [loading, setLoading] = useState(false)

  const [, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [filter, setFilter] = useState(false);

  const [show, setShow] = useState(false);
  // const [filtros, setFiltros] = useState({
  //   razao_social: '',
  //   fantasia: '',
  //   cpf_cnpj: '',
  //   ativo: true,
  // });


  useEffect(() => {
    listAllStatus(1);
  }, []);


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function listAllStatus(pageNumber) {
    setLoading(true);

    const values = getValues()

    let newFiltro = {
      ativo: values.ativo ?? true,
    }

    Status.listAll(pageNumber, newFiltro)
      .then((data) => {
        setStatusAtendimento(data.data.data);
        setTotalPages(data.data.paging.total_pages)
        setTotalRegistros(data.data.paging.total_records)
      })
      .catch((error) => {
        SweetAlert.error(error.response.data.message, 'Perguntas');
      })
      .finally(() => {
        // setFiltros(newFiltro)
        setLoading(false)
      });
  }

  const handlePageChange = (selected) => {
    setPage(selected.selected + 1)
    listAllStatus(selected.selected + 1);
  };

  function onFilter() {
    setFilter(true)
    setShow(false)
    listAllStatus(1)
  }

  function deletePergunta(id) {
    setLoading(true)
    Status.delete(id)
      .then((data) => {
        // SweetAlert.success('Categoria deletada com sucesso!', 'Categorias');
        listAllStatus()
      })
      .catch((error) => {
        SweetAlert.error(error.response.data.message, 'Status');
      })
      .finally(() => setLoading(false))
  }

  function deletePerguntaAlert(id) {
    SweetAlert.question('Atenção', 'Deletar status?', 'SIM!', () => deletePergunta(id), '#FF0000')
  }

  function editPergunta(id) {
    navigate(URL.status_cadastro + '/' + id)
  }

  return (
    <>
      {loading === true ? <Loading /> : ''}

      <Offcanvas show={show} onHide={handleClose} style={{ height: '100vh', backgroundColor: 'var(--app-panel-bg)' }} placement='bottom'>
        <Form onSubmit={handleSubmit(onFilter)}>
          <Container>
            <Offcanvas.Header closeButton>
              <TopTitlePage title='Filtro' />
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Card className='cardShadow'>
                <Card.Body className='p-3'>
                  <Row className='d-flex align-items-end'>
                    <Form.Group className="col-12 col-md-2">
                      <Form.Label>Situação</Form.Label>
                      <Form.Select {...register('ativo')} size='sm'>
                        <option value={true}>MOSTRAR</option>
                        <option value={false}>NÃO MOSTRAR</option>
                        <option value=''>TODOS</option>
                      </Form.Select>
                    </Form.Group>
                  </Row>

                </Card.Body>
              </Card>
              <div className='d-flex justify-content-end mt-3 gap-3'>
                <ButtonLimparAndFiltrar
                  handleClose={handleClose}
                  reset={reset}
                  listAll={listAllStatus}
                  setFilter={setFilter}
                />
              </div>
            </Offcanvas.Body>
          </Container>
        </Form>
      </Offcanvas>

      <div>
        <TopTitlePage title='Status' />

        <div className='py-3 d-flex justify-content-between px-3 align-items-end gap-2 flex-column flex-md-row'>

          <ButtonFilterAndSelect
            handleShow={handleShow}
            listAll={listAllStatus}
            filter={filter}
          />

          <div className='d-flex align-items-end gap-3 col-12 col-md-auto'>
            <Button
              variant='success'
              onClick={() => navigate(URL.status_cadastro)}
              className='col-12 col-md-auto'
            >+ Novo status</Button>
          </div>
        </div>

        <Card className='mx-3 cardShadow mb-2 lg-mb-0'>
          <Card.Body className='p-0'>

            {statusAtendimento.length === 0 ?
              <div className='d-flex justify-content-center py-2'>
                <h4>Sem registros</h4>
              </div>
              :
              <>
                <TableList>
                  <TableData
                    array={statusAtendimento}
                    editFunction={editPergunta}
                    deleteFunction={deletePerguntaAlert}
                  />
                </TableList>

                <div className='mt-4 d-flex justify-content-between px-3 flex-column flex-md-row gap-3'>
                  <span> Total: {totalRegistros}</span>
                  <ReactPaginate
                    pageCount={totalPages}
                    pageRangeDisplayed={1}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={'pagination_container'}
                    activeClassName={'active'}
                    previousLabel={'<'}
                    nextLabel={'>'}
                  />
                </div>
              </>
            }

          </Card.Body>
        </Card>


      </div>
    </>
  )
}

export default ListaStatus